import { environment } from "./environment";
// import { environment } from "./environment.prod";

const API_VERSION = "v1";

export const SERVER_URL = `${environment.serverUrl}/${API_VERSION}`;
// export const SERVER_URL = `http://localhost:7001/${API_VERSION}`;
export const AUTH_SERVICE_URL = `${SERVER_URL}/auth`;
export const BLOBS_SERVICE_URL = `${SERVER_URL}/blobs`;
export const CUSTOMER_TASK_SERVICE_URL = `${SERVER_URL}/client/tasks`;
export const CUSTOMER_TASK_DRAFT_SERVICE_URL = `${SERVER_URL}/client/task-drafts`;
export const CUSTOMER_STOCK_PRODUCT_SERVICE_URL = `${SERVER_URL}/client/stock_products`;
export const CUSTOMER_BRANCH_SERVICE_URL = `${SERVER_URL}/client/branches`;
export const CUSTOMER_INVOICE_SERVICE_URL = `${SERVER_URL}/client/invoices`;
export const CUSTOMER_ADDRESS_SERVICE_URL = `${SERVER_URL}/client/address`;
export const CUSTOMER_DASHBOARD_SERVICE_URL = `${SERVER_URL}/client/dashboard`;
export const CUSTOMER_SERVICE_REQUEST_SERVICE_URL = `${SERVER_URL}/client/service_requests`;
export const CUSTOMER_SUB_USER_SERVICE_URL = `${SERVER_URL}/client/sub_users`;
export const CUSTOMER_ACTIVITY_SERVICE_URL = `${SERVER_URL}/client/activity`;
export const CUSTOMER_SMS_SERVICE_URL = `${SERVER_URL}/client/sms`;

// export NODE_OPTIONS=--openssl-legacy-provider
